module.exports = __webpack_public_path__ + "img/32.081978f0.svg";